import { useMutation } from "@tanstack/react-query";
import { vehiclePriceApi } from "../../../modules/vehicle/price/api";
import { VehiclePriceRequest } from "../../../modules/vehicle/price/types";

export const VEHICLE_PRICE_QUERY_KEYS = {
  getVehiclePrice: (payload?: VehiclePriceRequest) => (payload ? ["getVehiclePrice", payload] : ["getVehiclePrice"]),
};

export const useGetVehiclePrice = () => {
  return useMutation({
    mutationKey: VEHICLE_PRICE_QUERY_KEYS.getVehiclePrice(),
    meta: { globalSpinner: false },
    mutationFn: async (payload: VehiclePriceRequest) => {
      const { data } = await vehiclePriceApi.getVehiclePrice(payload);

      return data;
    },
  });
};
